import { Box, Stack, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Check } from 'lucide-react'
import { FC, type ReactNode } from 'react'

type WizardStepIndicatorProps = {
    steps: { label: ReactNode }[]
    activeStep: number
}

export const WizardStepIndicator: FC<WizardStepIndicatorProps> = ({ steps, activeStep }) => {
    return (
        <Stack direction="row" alignItems="center" spacing={0} sx={{ pt: 1.5 }}>
            {steps.map((step, index) => {
                const isCompleted = index < activeStep
                const isActive = index === activeStep

                return (
                    <Stack key={index} direction="row" alignItems="center" sx={{ flex: index < steps.length - 1 ? 1 : undefined }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Box
                                sx={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: isCompleted
                                        ? 'success.main'
                                        : isActive
                                            ? 'primary.main'
                                            : 'action.disabledBackground',
                                    color: isCompleted || isActive ? 'primary.contrastText' : 'text.disabled',
                                    fontSize: '0.75rem',
                                    fontWeight: 600,
                                }}
                            >
                                {isCompleted
                                    ? <C1Icon icon={Check} sx={{ fontSize: 14 }} />
                                    : index + 1
                                }
                            </Box>
                            <Typography
                                variant="body2"
                                fontWeight={isActive ? 600 : 400}
                                color={isActive ? 'text.primary' : isCompleted ? 'text.secondary' : 'text.disabled'}
                                noWrap
                            >
                                {step.label}
                            </Typography>
                        </Stack>
                        {index < steps.length - 1 && (
                            <Box
                                sx={{
                                    flex: 1,
                                    height: 2,
                                    mx: 2,
                                    backgroundColor: isCompleted ? 'success.main' : 'divider',
                                    borderRadius: 1,
                                }}
                            />
                        )}
                    </Stack>
                )
            })}
        </Stack>
    )
}
